import React from 'react'
import { useBaseTextStyle } from '../../ions/styles'
import { Text } from 'react-native'
import { helpers } from '@linqpal/common-frontend'

const { composeStyle } = helpers

export const TextMediumHeading = ({ style, ...props }) => {
  const { mediumHeading } = useBaseTextStyle()
  return <Text style={composeStyle(mediumHeading, style)} {...props} />
}
